export default {"src":"/_next/static/media/trustpilot-star-empty.b754542d.svg","height":35,"width":36,"blurWidth":0,"blurHeight":0};